import dayjs from 'dayjs';

const isObject = (val: any): val is Record<string, any> => typeof val === 'object' && val !== null && !Array.isArray(val);

function processRequestSubObjectItem(formData: FormData, key: string, subValue: unknown): void {
  if (subValue === undefined || subValue === null) {
    return;
  }
  if (subValue instanceof Blob) {
    formData.append(key, subValue);
    return;
  }
  if (subValue instanceof Date || dayjs.isDayjs(subValue)) {
    formData.append(key, subValue.toISOString());
    return;
  }
  if (Array.isArray(subValue)) {
    subValue.forEach((item, index) => {
      if (item === undefined || item === null) return;
      processRequestSubObjectItem(formData, `${key}[${index}]`, item);
    });
    return;
  }
  if (isObject(subValue)) {
    Object.entries(subValue).forEach(([subKey, value]) => {
      processRequestSubObjectItem(formData, `${key}[${subKey}]`, value);
    });
    return;
  }
  formData.append(key, String(subValue));
}

export const RequestObjectToFormData = <T extends {},>(requestObject: T): FormData => {
  const formData = new FormData();

  Object.entries(requestObject).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return;
    }
    if (value instanceof Blob) {
      formData.append(key, value);
      return;
    }
    if (value instanceof Date || dayjs.isDayjs(value)) {
      formData.append(key, value.toISOString());
      return;
    }
    if (Array.isArray(value)) {
      value.forEach((item, index) => {
        if (item === undefined || item === null) return;
        processRequestSubObjectItem(formData, `${key}[${index}]`, item);
      });
      return;
    }
    if (isObject(value)) {
      processRequestSubObjectItem(formData, key, value);
      return;
    }
    formData.append(key, String(value));
  });

  return formData;
}
